/**
 * Client-side mirror of server/_core/teamVerticals.ts's allowlist/parsing.
 * Kept as a plain module (not inline in TeamMemberDashboard.tsx) so it can be
 * unit tested without pulling in the whole page component, and reused as the
 * fallback path for sessions stored in sessionStorage before the server
 * started returning the parsed `assignedVerticals` array.
 */
export const VERTICAL_ALLOWLIST = ["Scale360", "Fundable360", "Share360", "Legacy360", "Media360"] as const;

export function parseVerticalsClient(raw: string | null | undefined): string[] {
  if (!raw) return [];
  const seen = new Set<string>();
  const result: string[] = [];
  for (const part of raw.split(",")) {
    const trimmed = part.trim();
    if (!trimmed) continue;
    const match = VERTICAL_ALLOWLIST.find(v => v.toLowerCase() === trimmed.toLowerCase());
    if (!match || seen.has(match)) continue;
    seen.add(match);
    result.push(match);
  }
  return result;
}
